// QUAL CONTA ESTA ABA ESTÁ USANDO.
//
// Cada conta aberta no navegador ocupa uma VAGA, e a vaga vira o caminho do
// cookie de renovação (`/api/v1/auth/u/0`). Duas abas com vagas diferentes
// renovam credenciais diferentes, e o navegador impede uma de alcançar a
// outra — ver api/interno/web/cookie.go.
//
// A vaga vive em `sessionStorage` por dois motivos:
//
//  1. É POR ABA. `localStorage` é compartilhado, e com ele a segunda aba
//     sobrescreveria a vaga da primeira — recriando, num campo novo,
//     exatamente o defeito que as vagas corrigem.
//  2. SOBREVIVE AO F5, que `localStorage` também faria, mas memória não.
//     Sem isso, recarregar a página perderia a conta da aba e ela cairia na
//     vaga de outra pessoa.
//
// E GUARDAR UM NÚMERO AQUI NÃO É GUARDAR CREDENCIAL. A regra de deposito.ts
// continua inteira: o refresh segue no cookie HttpOnly, fora do alcance
// deste código. Um XSS que leia esta chave descobre "esta aba é a vaga 1" —
// e não consegue fazer nada com isso que já não pudesse fazer.

const CHAVE = "cdw_vaga";

export function vagaDaAba(): number | null {
  try {
    const cru = sessionStorage.getItem(CHAVE);
    if (cru === null) return null;
    const n = Number(cru);
    return Number.isInteger(n) && n >= 0 ? n : null;
  } catch {
    // Navegador com armazenamento bloqueado (janela anônima restrita,
    // política corporativa) não pode derrubar o webmail. Sem vaga, a aba cai
    // no caminho antigo, que continua funcionando — uma conta por vez.
    return null;
  }
}

export function guardarVagaDaAba(vaga: number | null | undefined): void {
  try {
    if (vaga === null || vaga === undefined) {
      sessionStorage.removeItem(CHAVE);
      return;
    }
    sessionStorage.setItem(CHAVE, String(vaga));
  } catch {
    // Mesmo motivo do catch acima: isto é conveniência, não correção.
  }
}

/**
 * O caminho de renovação desta aba.
 *
 * Sem vaga devolve o caminho ANTIGO, e isso é o que mantém de pé quem já
 * estava logado antes das vagas existirem: o servidor migra a sessão para
 * uma vaga na primeira renovação e devolve o número, que a aba então guarda.
 */
export function caminhoDeRenovacao(): string {
  const vaga = vagaDaAba();
  return vaga === null ? "/auth/refresh" : `/auth/u/${vaga}/refresh`;
}
